import { createMuiTheme } from '@material-ui/core/styles';

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#73351f',
    },
    secondary: {
      main: '#a84e25',
    },
    background: {
      default: '#fff0c8'
    }
    // ,
    // fillcolor:{
    //   default: green
    // }
  },
  typography: {
    // Tell Material-UI what's the font-size on the html element is.
    htmlFontSize: 20,
    fontFamily: '"Segoe UI", "Trebuchet MS", Arial, sans-serif',
  },
});

export default theme;
